import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import matchSorter from "match-sorter";
import ReactExport from "react-data-export";
import swal from "sweetalert";
import moment from "moment";
import LotesMovAlmacenService from "../services/LotesMovAlmacenService";
import {notificarError} from "../componentes/Almacenes/AlmacenNotify";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;


function getDataExportExcel(dataSet) {
    const data = dataSet.filter(x => x);
    return [
        {
            columns: [
                {
                    title: "Código Lote",
                    width: {wpx: 100}
                },
                {
                    title: "Código Producto",
                    width: {wpx: 120}
                },
                {
                    title: "Nombre Producto",
                    width: {wpx: 300}
                },
                {
                    title: "Fecha Ingreso",
                    width: {wpx: 120}
                },
                {
                    title: "Fecha Vencimiento",
                    width: {wpx: 120}
                },
                {
                    title: "Cantidad",
                    width: {wpx: 80}
                },
            ],

            data: data.map(row => {
                return [
                    {
                        value: row.Codigo || "",
                        style: {
                            fill: {patternType: "solid", fgColor: {rgb: "F6F8FA"}}
                        }
                    },
                    {
                        value: row.CodigoProducto || "",
                        style: {
                            fill: {patternType: "solid", fgColor: {rgb: "F6F8FA"}}
                        }
                    },
                    {
                        value: row.NombreProducto || "",
                        style: {
                            fill: {patternType: "solid", fgColor: {rgb: "F6F8FA"}}
                        }
                    },
                    {
                        value: row.FechaIngreso || "",
                        style: {
                            fill: {patternType: "solid", fgColor: {rgb: "F6F8FA"}}
                        }
                    },
                    {
                        value: row.FechaVencimiento || "",
                        style: {
                            fill: {patternType: "solid", fgColor: {rgb: "F6F8FA"}}
                        }
                    },
                    {
                        value: row.Cantidad || 0,
                        style: {
                            fill: {patternType: "solid", fgColor: {rgb: "F6F8FA"}}
                        }
                    },
                ];
            })
        }
    ];
}

class LotesMovAlmacenUI extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            dataLotes: []
        }
        this.lotesService = new LotesMovAlmacenService();
        this.generarReporte = this.generarReporte.bind(this);
        this.fetchAllLotes = this.fetchAllLotes.bind(this);
    }

    async generarReporte() {
        const willGenerate = await swal({
            title: "Reporte de excel de todos los lotes",
            text: "Esto va a tomar un tiempo acorde a la cantidad de lotes registrados, ¿está seguro?",
            icon: "info",
            buttons: true,
            closeOnClickOutside: false
        });
        if (willGenerate)
            this.fetchAllLotes();
    }

    async fetchAllLotes() {
        this.setState({isLoading: true, dataLotes: []})
        let lotes = await this.lotesService.filtrarLotes({
            page: 1,
            pageSize: 10,
            sorted: [],
            filtered: []
        }, {filterAll: "1"})
        if (lotes) {
            const dataExport = getDataExportExcel(lotes.lotes);
            this.setState({dataLotes: dataExport})
        } else
            notificarError("No se ha podido extraer todos los lotes.")
        this.setState({isLoading: false})
    }

    render() {
        const props = this.props;
        const table = props.tableInfo;
        return (
            <section className="ventas-fpay-section-vh pt-5">
                <div className="container">
                    <div className="ProcesarBoton mt-1 mb-3">
                        <div className="ProcesarBotones">
                            <button
                                className="btn-excel-mfp"
                                title="Descargar datos en EXCEL"
                                disabled={this.state.isLoading}
                                onClick={this.generarReporte}
                            >
                                <a className="">Excel</a>
                            </button>

                            {this.state.dataLotes.length ? (
                                <ExcelFile
                                    element={
                                        <button disabled={this.state.isLoading}
                                            className="btn btn-naranja-mfp ml-2">Descargar</button>
                                    }
                                    filename="ReporteLotesMovAlmacen"
                                >
                                    <ExcelSheet
                                        dataSet={this.state.dataLotes}
                                        name="Lotes"
                                    >
                                    </ExcelSheet>
                                </ExcelFile>
                            ) : null}
                        </div>

                    </div>
                    {
                        <ReactTable
                            id="table-lotes-to-xls"
                            data={props.data}
                            pages={table.pages}
                            loading={table.isLoading}
                            defaultFilterMethod={(filter, row) =>
                                String(row[filter.id]) === filter.value
                            }
                            manual={true}
                            filterable={true}
                            sortable={true}
                            onFetchData={(state, instance) => props.onFilterLotes(state, instance)}
                            columns={[
                                {
                                    columns: [
                                        {
                                            Header: "Código Lote",
                                            id: "Codigo",
                                            width: 120,
                                            accessor: d => d.Codigo,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {keys: ["Codigo"]}),
                                            filterAll: true
                                        },
                                        {
                                            Header: "Código Producto",
                                            id: "CodigoProducto",
                                            width: 130,
                                            accessor: d => d.CodigoProducto,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {keys: ["CodigoProducto"]}),
                                            filterAll: true
                                        },
                                        {
                                            Header: "Nombre Producto",
                                            id: "NombreProducto",
                                            width: 350,
                                            accessor: d => d.NombreProducto,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {keys: ["NombreProducto"]}),
                                            filterAll: true
                                        },
                                        {
                                            Header: "Fecha Ingreso",
                                            id: "FechaIngreso",
                                            width: 130,
                                            accessor: d => moment(d.FechaIngreso).format('DD-MM-YYYY'),
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {keys: ["FechaIngreso"]}),
                                            filterAll: true
                                        },
                                        {
                                            Header: "Fecha Vencimiento",
                                            id: "FechaVencimiento",
                                            width: 250,
                                            accessor: d => {
                                                const remainingDays = moment(d.FechaVencimiento).diff(moment(), 'days');

                                                if (remainingDays < 0) {
                                                    return `${moment(d.FechaVencimiento).format('DD-MM-YYYY')} - Vencido`;
                                                }

                                                if (remainingDays < 30) {
                                                    return `${moment(d.FechaVencimiento).format('DD-MM-YYYY')} - Restan: ${remainingDays} días`;
                                                }
                                                const months = moment(d.FechaVencimiento).diff(moment(), 'months');
                                                
                                                if (months > 1) {
                                                    return `${moment(d.FechaVencimiento).format('DD-MM-YYYY')} - Restan: ${months} meses`;
                                                } else {
                                                    return `${moment(d.FechaVencimiento).format('DD-MM-YYYY')} - Restan: ${months} mes`;
                                                }
                                            },
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {keys: ["FechaVencimiento"]}),
                                            filterAll: true
                                        },
                                        {
                                            Header: "Cantidad",
                                            id: "Cantidad",
                                            width: 100,
                                            accessor: d => d.Cantidad,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {keys: ["Cantidad"]}),
                                            filterAll: true,
                                            getProps: (state, rowInfo, column) => {
                                                return {
                                                    style: {
                                                        textAlign: "right"
                                                    }
                                                };
                                            }
                                        }
                                    ]
                                }
                            ]}
                            defaultPageSize={10}
                            className="-striped -highlight"
                            previousText="Anterior"
                            nextText="Siguiente"
                            noDataText="No se encontraron registros"
                            loadingText="Cargando..."
                            ofText="de"
                            rowsText="filas"
                            pageText="Página"
                            pageSizeOptions={[10, 20, 25, 50, 100]}
                        />
                    }
                </div>
            </section>
        );
    }
}

export default LotesMovAlmacenUI;

